module.exports = __webpack_public_path__ + "static/secondMovementTransformed-94ea37245925676f08672ce54a7ae524.mp3";